import jQuery from "jquery";
// import "../common/zoom.js";
import "jquery-zoom";
import { tns } from "tiny-slider/src/tiny-slider.js";
window.$ = window.jQuery = jQuery;

document.querySelectorAll(".h2").forEach((el) => {
    const texto = el.innerText.trim();
    const palavras = texto.split(" ");
    if (palavras.length > 0) {
        const primeira = palavras.shift(); // pega a primeira e remove
        el.innerHTML = `<strong>${primeira}</strong> ${palavras.join(" ")}`;
    }
});

const openButtons = document.querySelectorAll(".btnOpen");
const closeButtons = document.querySelectorAll(".btnClose");

openButtons.forEach((button) => {
    button.addEventListener("click", () => {
        const id = button.getAttribute("data-id");
        const modal = document.getElementById(`tabelaNutricional-${id}`);
        if (modal) {
            modal.classList.add("active");
            modal.querySelector(".tabNutri").classList.add("active");
            if (window.innerWidth >= 1024) {
                // desktop
                document.body.style.overflow = "hidden";
                document.documentElement.style.overflow = "hidden";
            }
        }
    });
});

closeButtons.forEach((button) => {
    button.addEventListener("click", () => {
        const id = button.getAttribute("data-close");
        const modal = document.getElementById(`tabelaNutricional-${id}`);
        if (modal) {
            modal.querySelector(".tabNutri").classList.remove("active");
            modal.classList.remove("active");
            if (window.innerWidth >= 1024) {
                document.body.style.overflow = "";
                document.documentElement.style.overflow = "";
            }
        }
    });
});

window.addEventListener("click", (e) => {
    document.querySelectorAll(".tabelaNutricional").forEach((modal) => {
        if (e.target === modal) {
            modal.querySelector(".tabNutri").classList.remove("active");
            modal.classList.remove("active");
            if (window.innerWidth >= 1024) {
                document.body.style.overflow = "";
                document.documentElement.style.overflow = "";
            }
        }
    });
});

let produtoDetalhe = $(".produtoDetalhe");
if (produtoDetalhe.length > 0) {
    if ($(window).width() > 1024) {
        function imageZoom(imgID, resultID) {
            var img, lens, result, cx, cy;
            img = document.getElementById(imgID);
            result = document.getElementById(resultID);
            /* Create lens: */
            lens = document.createElement("DIV");
            lens.setAttribute("class", "img-zoom-lens");

            if (img?.parentElement) {
                /* Insert lens: */
                img.parentElement.insertBefore(lens, img);
                /* Calculate the ratio between result DIV and lens: */
                cx = result.offsetWidth / lens.offsetWidth;
                cy = result.offsetHeight / lens.offsetHeight;
                cx = 2;
                cy = 2;
                /* Set background properties for the result DIV */
                result.style.backgroundImage = "url('" + img.src + "')";
                result.style.backgroundSize =
                    img.width * cx + "px " + img.height * cy + "px";
                /* Execute a function when someone moves the cursor over the image, or the lens: */
                lens.addEventListener("mousemove", moveLens);
                img.addEventListener("mousemove", moveLens);
                /* And also for touch screens: */
                lens.addEventListener("touchmove", moveLens);
                img.addEventListener("touchmove", moveLens);

                function moveLens(e) {
                    var pos, x, y;
                    /* Prevent any other actions that may occur when moving over the image */
                    e.preventDefault();
                    /* Get the cursor's x and y positions: */
                    pos = getCursorPos(e);
                    /* Calculate the position of the lens: */
                    x = pos.x - lens.offsetWidth / 2;
                    y = pos.y - lens.offsetHeight / 2;
                    /* Prevent the lens from being positioned outside the image: */
                    if (x > img.width - lens.offsetWidth) {
                        x = img.width - lens.offsetWidth;
                    }
                    if (x < 0) {
                        x = 0;
                    }
                    if (y > img.height - lens.offsetHeight) {
                        y = img.height - lens.offsetHeight;
                    }
                    if (y < 0) {
                        y = 0;
                    }
                    /* Set the position of the lens: */
                    lens.style.left = x + "px";
                    lens.style.top = y + "px";
                    /* Display what the lens "sees": */
                    result.style.backgroundPosition =
                        "-" + x * cx + "px -" + y * cy + "px";
                }

                function getCursorPos(e) {
                    var a,
                        x = 0,
                        y = 0;
                    e = e || window.event;
                    /* Get the x and y positions of the image: */
                    a = img.getBoundingClientRect();
                    /* Calculate the cursor's x and y coordinates, relative to the image: */
                    x = e.pageX - a.left;
                    y = e.pageY - a.top;
                    /* Consider any page scrolling: */
                    x = x - window.pageXOffset;
                    y = y - window.pageYOffset;
                    return { x: x, y: y };
                }
            }
        }

        imageZoom("imgProduto", "imgZoom");
    }
}

let sliderProduto = $(".sliderProduto");
if (sliderProduto.length > 0) {
    let slider = tns({
        container: ".carouselProduto",
        items: 1,
        mouseDrag: true,
        controls: true,
        nav: false,
        loop: false,
        mouseDrag: true,
        touch: true,
        controlsText: ["", ""],
    });
}

const productsPageCarousel = document.querySelector(".productsPageCarouselSlider");
if (productsPageCarousel) {
    const totalItems = productsPageCarousel.querySelectorAll(".productsPageCarouselItem").length;

    tns({
        container: ".productsPageCarouselSlider",
        items: 1,
        slideBy: 1,
        controls: totalItems > 1,
        nav: false,
        loop: totalItems > 1,
        mouseDrag: totalItems > 1,
        touch: true,
        autoplay: false,
        controlsText: ["", ""],
    });
}

const productsSidebar = document.querySelector(".produtosListaPage .sidebar");
const filterToggle = document.querySelector(".produtosListaPage .filterToggle");
const filterClose = document.querySelector(".produtosListaPage .filterClose");
const productSearchForms = document.querySelectorAll(".produtosListaPage .searchForm");

productSearchForms.forEach((form) => {
    form.addEventListener("submit", () => {
        const searchInput = form.querySelector('input[name="busca"]');

        if (searchInput && searchInput.value.trim() === "") {
            searchInput.disabled = true;
        }
    });
});

if (productsSidebar && filterToggle) {
    const syncFilterState = (isOpen) => {
        productsSidebar.classList.toggle("active", isOpen);
        filterToggle.setAttribute("aria-expanded", String(isOpen));
    };

    filterToggle.addEventListener("click", () => {
        syncFilterState(!productsSidebar.classList.contains("active"));
    });

    if (filterClose) {
        filterClose.addEventListener("click", () => {
            syncFilterState(false);
        });
    }

    window.addEventListener("resize", () => {
        if (window.innerWidth > 768) {
            syncFilterState(false);
        }
    });
}
